import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className='bg-neutral-dark border-t border-neutral'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12'>
        <div className='grid grid-cols-1 md:grid-cols-3 gap-10'>
          {/* About Section */}
          <div>
            <h3 className='text-lg font-bold text-primary-light mb-4'>About Us</h3>
            <p className='text-neutral-light text-sm leading-relaxed'>
              Natco Pharmacy ensures the authenticity of your products using advanced verification
              technology for safer healthcare.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className='text-lg font-bold text-primary-light mb-4'>Quick Links</h3>
            <ul className='space-y-2 text-sm'>
              {[
                { to: '/', label: 'Home' },
                { to: '/about', label: 'About Us' },
                { to: '/privacy', label: 'Privacy Policy' },
                { to: '/terms', label: 'Terms & Conditions' },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className='text-neutral hover:text-primary-dark transition-colors'
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className='text-lg font-bold text-primary-light mb-4'>Contact</h3>
            <ul className='space-y-3 text-sm text-neutral'>
              <li className='flex'>
                <span className='w-20 font-medium text-neutral-light'>Email:</span>
                <span>info@natcopharmacy.com</span>
              </li>
              <li className='flex hidden'>
                <span className='w-20 font-medium text-neutral-light'>Phone:</span>
                <span>+1 (555) 123-4567</span>
              </li>
              <li className='flex hidden'>
                <span className='w-20 font-medium text-neutral-light'>Address:</span>
                <span>
                  123 Medical Plaza,
                  <br />
                  Healthcare City
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className='border-t border-neutral mt-10 pt-6 text-center'>
          <p className='text-sm text-neutral'>
            &copy; {new Date().getFullYear()}{' '}
            <span className='text-primary-light'>Natco Pharmacy</span>. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
